import { ProductType } from "../../../../common/interfaces/enums/ProductType";
import IApiHealthClient from "../../../interfaces/api/group/case/config/clients/IApiHealthClient";
import { IApiGroupCaseConfig } from "../../../interfaces/api/group/case/config/IApiGroupCaseConfig";
import { IApiGroupCaseConfigHealth } from "../../../interfaces/api/group/case/config/IApiGroupCaseConfigHealth";
import { IApiGroupCaseHealth } from "../../../interfaces/api/group/case/IApiGroupCaseHealth";
import { IClient } from "../../../../common/interfaces/IClient";
import ISettingClientHealth from "../../../../common/interfaces/settings/clients/ISettingClientHealth";
import { IQuoteSettingContainerHealth } from "../../../../common/interfaces/settings/IQuoteSettingContainerHealth";
import { IQuoteSettingsContainerBase } from "../../../../common/interfaces/settings/IQuoteSettingsContainerBase";
import { Client } from "./BaseClientMapper";
import {
    assembleMapper,
    localToRemoteMapper,
    remoteToLocalMapper
} from "./SettingMapper";

const mapRemoteClientToLocal = (clients: IApiHealthClient[]): ISettingClientHealth[] => {
    return clients.map((client) => {
        return {
            ...Client.remoteToLocal(client),
            hasDentalAndOpticalOption: client.hasDentalAndOpticalOption,
            hasSpecialistsAndTestsOption: client.hasSpecialistsAndTestsOption,
            hasGPOption: client.hasGPOption,
            excess: client.excess
        };
    });
};

const mapRemoteSettingToLocal = (
    baseSettings: IQuoteSettingsContainerBase,
    extension: IApiGroupCaseHealth
): IQuoteSettingContainerHealth => {
    return {
        ...baseSettings,
        clients: mapRemoteClientToLocal(extension.clients),
        allowChildren: true,
        productType: ProductType.Health
    };
};

const mapLocalSettingToRemote = (
    baseSetting: IApiGroupCaseConfig,
    extension: IQuoteSettingContainerHealth,
    clients: IApiHealthClient[]
): IApiGroupCaseConfigHealth => {
    return {
        ...baseSetting,
        clients
    };
};

const mapLocalClientToRemote = (
    client: IClient,
    setting: IQuoteSettingContainerHealth
): IApiHealthClient => {
    const settingClient = setting.clients.find((c) => c.personId === client.personId);

    return {
        ...Client.localToRemote(client),
        hasDentalAndOpticalOption: settingClient.hasDentalAndOpticalOption,
        hasGPOption: settingClient.hasGPOption,
        hasSpecialistsAndTestsOption: settingClient.hasSpecialistsAndTestsOption,
        excess: settingClient.excess
    };
};

const remoteToLocal = (settings: IApiGroupCaseHealth): IQuoteSettingContainerHealth =>
    remoteToLocalMapper(settings, mapRemoteSettingToLocal);

const localToRemote = (
    clients: IClient[],
    settings: IQuoteSettingContainerHealth
): IApiGroupCaseConfigHealth =>
    localToRemoteMapper(
        clients,
        settings,
        mapLocalSettingToRemote,
        mapLocalClientToRemote
    );

export default assembleMapper(remoteToLocal, localToRemote);
